import * as z from 'zod'

import { CreateW2MasterVars, UpdateW2MasterVars } from '@/common/api/params/w2Master'
import { StringLength } from '@/common/form/schema'
import { MasterType, W2MasterData, W2_MASTER_CONFIGS } from '@/common/model/master/w2Master'

export const makeMasterSchema = (masterType: MasterType) => {
  return z.object(
    W2_MASTER_CONFIGS[masterType].csvHeaders.reduce(
      (schema, header) => {
        const required = W2_MASTER_CONFIGS[masterType].requiredCsv.includes(header)
        return {
          ...schema,
          [header]: required
            ? z.string().max(StringLength.TEXT_MAX).min(1)
            : z.string().max(StringLength.TEXT_MAX).optional()
        }
      },
      {} as Record<string, z.ZodTypeAny>
    )
  )
}

export const convertMasterSchemaToVars = (
  schema: Record<string, any>,
  siteId: number,
  masterType: MasterType
): CreateW2MasterVars => {
  return {
    master_type: masterType,
    site_id: siteId,
    // @ts-ignore
    data: schema
  }
}

export const convertMasterSchemaToUpdateVars = (
  schema: Record<string, any>,
  siteId: number,
  masterType: MasterType,
  recordId: number
): UpdateW2MasterVars => {
  return {
    master_type: masterType,
    site_id: siteId,
    record_id: recordId,
    // @ts-ignore
    data: schema
  }
}

export const convertMasterToSchema = (master: W2MasterData) => {
  return {
    ...master.data
  }
}
